'use client';
import { z } from 'zod';

export const reportListingSchema = z.object({
  fullName: z.string().min(1, 'Full name is required'),
  email: z.string().email('Invalid email').min(1, 'Email is required'),
  phoneNumber: z
    .string()
    .optional()
    .refine((v) => !v || /^\+?[0-9\-\s]{7,15}$/.test(v), { message: 'Invalid phone number' }),
  reason: z.string().min(1, 'Please select a reason'),
  description: z.string().min(1, 'Description is required'),
});

export type ReportListingFormValues = z.infer<typeof reportListingSchema>;

export const emailVehicleSchema = z.object({
  yourName: z.string().min(1, 'Your name is required'),
  yourEmail: z.string().min(1, 'Your email is required').email('Invalid email'),
  friendName: z.string().min(1, 'Friend name is required'),
  friendEmail: z.string().min(1, 'Friend email is required').email('Invalid email'),
  message: z.string().min(1, 'Message is required'),
  sendMeACopy: z.boolean().optional(),
  signMeUp: z.boolean().optional(),
});

export type EmailVehicleFormValues = z.infer<typeof emailVehicleSchema>;
